<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa340-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnPrint', //Print
                      'btnExcel'   //Save Excel
                    ]"
                  @btnRetrieve="btnRetrieve()"
                  @btnPrint="btnPrint()"
                  @btnExcel="btnExcel()"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Ship No. : </span>
                      <v-col cols="2">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line                            
                            outlined
                            dense
                            label="Select"
                            @change="shipNoChange()"
                          ></v-select>
                      </v-col>

                      <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">PO/POR Status : </span>
                        <v-col cols="2">
                            <v-select
                              v-model="rptSta"
                              :items="rptStaList"
                              return-object
                              single-line
                              outlined
                              dense
                              label="Select"
                              @change="changeRptSta()"
                            ></v-select>
                        </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epmsa340" 
                    class="hipGridHeight1_1" 
                    :ref="epmsa340Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="shipNo" caption="Ship" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="lotNo" caption="Lot No" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="wgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>

                    <DxColumn caption="POR No" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="porNo" caption="Description" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="POR Date" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="porDte" caption="Description" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Mat.Code" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="matlCd" caption="Description" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Rec.Date" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="recvDte" caption="Description" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="PO Date" width="6%"  data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="poDte" caption="PO Status" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="PO Qty" width="6%" alignment="center" :allow-editing="false" data-type="number" format="#,##0" >
                      <DxColumn data-field="poQty" caption="PO Amount" width="6%" alignment="Right" :allow-editing="false"  data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn caption="Dely. Date" width="6%"  data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="delyDte" caption="Dely.No" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="W/H Date" width="6%"  data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="whQty" caption="Qty" width="6%" alignment="center" :allow-editing="false" data-type="number" format="#,##0" />
                      <DxColumn data-field="whAmtVnd" caption="Amount" width="6%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn data-field="rmk" caption="Remark" width="5%" data-type="string" alignment="left" :allow-editing="false"/>
                    <!-- <template #dataRowTemplate="{ data: rowInfo }">
                      <tr>
                        <td rowspan="2">{{ rowInfo.data.rnum }}</td>
                        <td rowspan="2">{{ rowInfo.data.shinNo }}</td>
                        <td rowspan="2">{{ rowInfo.data.block }}</td>
                        <td rowspan="2">{{ rowInfo.data.lotNo }}</td>
                        <td rowspan="2">{{ rowInfo.data.wgt }}</td>
                        <td>{{ rowInfo.data.porDte }}</td>
                        <td>{{ rowInfo.data.matlCd }}</td>
                        <td>{{ rowInfo.data.recvDte }}</td>
                        <td>{{ rowInfo.data.poDte }}</td>
                        <td>{{ rowInfo.data.delyDte }}</td>
                        <td colspan="2" >{{ rowInfo.data.whDte }}</td>
                        <td rowspan="2">{{ rowInfo.data.rmk }}</td>
                      </tr>
                      <tr>
                        <td colspan="4"><div>{{ rowInfo.data.partSpec }}</div></td>
                        <td>{{ rowInfo.data.porNo }} + '-' + {{ rowInfo.data.porSeq }}</td>
                        <td>{{ rowInfo.data.porAmount }}</td>
                        <td>{{ rowInfo.data.delyNo }}</td>
                        <td>{{ rowInfo.data.delyNo }}</td>
                        <td>{{ rowInfo.data.whQty }}</td>
                        <td>{{ rowInfo.data.whAmtVnd }}</td>
                      </tr>
                    </template>   -->
                    <DxPaging :enabled="true" :page-size="60" />
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { epmsa340, epmsa340Xls } from '@/api/view/hip/A/epmsa340.js'
import { getShipNoList1} from '@/api/view/hip/common/common.js'
import { reportView } from '@/api/view/hip/common/common.js'

export default {
  name: 'epmsa340',
  mixins: [baseview, BaseDataGrid],
  components: {
  },

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve','btnPrint','btnExcel'],
      epmsa340Ref: 'epmsa340Ref',
      gridMainList: [],
      shipNoList: [],
      rptStaList: ['All' , 'Waiting Deli.', 'Waiting W/H', 'Not PO yet', 'Finished'],
      rptStaDesc: 'All',
      shipNo: '',
      rptSta: '',
      makerCd: this.$store.state.user.makerCd
    }
  },

  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa340Ref)
    },
  },
  mounted() {
    this.getList()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.btnRetrieve()
  },
  methods: {
    async getList(){
      try {
        this.openLoading('searching')
        let param = {
          makerCd: this.$store.state.user.makerCd
        }
        await getShipNoList1(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
        })

      } finally {
      this.endLoading()
      }
    },
    changeRptSta(){
      if(this.rptStaDesc === 'Waiting Deli.'){
        this.rptSta = '2'
      } else if(this.rptStaDesc === 'Waiting W/H'){
        this.rptSta = '3'
      } else if(this.rptStaDesc === 'Not PO yet'){
        this.rptSta = '4'
      } else if(this.rptStaDesc === 'Finished'){
        this.rptSta = '5'
      } else {
        this.rptSta = '%'
      }
      this.btnRetrieve()
    },
    async getMainList(){
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
          shipNo : this.shipNo,
          rptSta  : this.rptSta
        }
        
        await epmsa340(params).then(res => {
          let list = []
          let cnt = 1;

          res.list.forEach(e => {
            list.push(
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, block : e.block, lotNo : e.lotNo, wgt : e.wgt, 
                porNo: e.porNo + '-' + e.porSeq, porDte: e.porDte, matlCd: e.matlCd, recvDte: e.recvDte, poDte: e.poDte, 
                poQty: e.poQty,  delyDte: e.delyDte, whQty: e.whDte, whAmtVnd: e.whDte, rmk: e.rmk
              },
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo,  block : e.block, lotNo : e.lotNo, wgt : e.wgt, 
                porNo: e.partSpec, porDte: e.partSpec, matlCd: e.partSpec, recvDte: e.partSpec,  poDte: e.poStat == 4 ? 'Already PO' : 'Not Yet PO', 
                poQty: e.poAmtVnd,  delyDte: e.delyNo, whQty: e.whQty, whAmtVnd: e.whAmtVnd, rmk: e.rmk
              },
              
            )
          });
          this.gridMainList = list
        })
      } finally {
      this.endLoading()
      }
    },
    shipNoChange(){
      this.btnRetrieve()
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    btnPrint(){
      const param = {
        fileName: 'epmsa340prt.jrxml',
        as_ship_no: this.shipNo,
        as_rpt_sta: this.rptSta,
        as_maker_cd: this.$store.state.user.makerCd
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnExcel(){
      this.openLoading('searching')
      const params = {
          makerCd: this.$store.state.user.makerCd,
          shipNo : this.shipNo,
          rptSta  : this.rptSta
        }      
      epmsa340Xls(params)
      this.endLoading()
    },
    //cell merge
    cellPrepared(e){
      if(e.rowType === 'data'){
        if(e.column.caption === 'No' || e.column.caption === 'Ship' || e.column.caption === 'Block' || e.column.caption === 'Lot No' || e.column.caption === 'Weight' || e.column.caption === 'Remark' ) 
          {
            if(e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')){
              e.cellElement.setAttribute('rowspan', 2)
            }else {
              e.cellElement.style.display = 'none'
            }
          }
          
          if (Number(e.rowIndex) % 2 != 0) { 
            
            if(e.column.caption === 'Description' && e.columnIndex === 5 ){
                e.cellElement.setAttribute('colspan', 4)
            } else if(e.column.caption === 'Description') {
                if(e.columnIndex === 6 || e.columnIndex == 7 || e.columnIndex === 8){
                    if(e.value === e.component.cellValue(e.rowIndex, e.columnIndex - 1)){
                        e.cellElement.style.display = 'none'
                      }
                }
            }
          }
          
          if (Number(e.rowIndex) % 2 === 0) { 

            if(e.column.caption == 'Qty' &&  e.columnIndex === 12) 
            {
              e.cellElement.setAttribute('colspan', 2)
              e.cellElement.style.alignment = 'center'
            } else if(e.column.caption === 'Amount' && e.columnIndex === 13){
                e.cellElement.style.display = 'none'
            }
          }
      } else {

        if(e.column.caption === 'Description' && e.columnIndex === 0){
          e.cellElement.setAttribute('colspan', 4)
        } else if(e.column.caption === 'Description' && (e.columnIndex === 1 || e.columnIndex === 2 || e.columnIndex === 3)){
          e.cellElement.style.display = 'none'
        }
      }

    },
  }
}
</script>
<style lang="scss" scoped>
.epmsa340-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }

  ::v-deep.text__dely-no {
    input {
      text-align: center;
    }
  }
}
</style>